import { render, staticRenderFns } from "./EditInspectionRoute.vue?vue&type=template&id=738d80cd"
import script from "./EditInspectionRoute.vue?vue&type=script&lang=js"
export * from "./EditInspectionRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports